import { LogLevel } from "angular-auth-oidc-client";

export const environment = {
    production: true,
    identityConfig: {
        authority: 'https://identity.nside.io',
        redirectUrl: `https://assess-v2.nside.io/redirect`,
        postLogoutRedirectUri: 'https://v2.nside.io/Default.aspx',
        clientId: 'assess.nside.io',
        scope: 'api.nside.io openid roles profile offline_access',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: `https://assess-v2.nside.io/silent-renew`,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        logLevel: LogLevel.Debug
    },
    apiBaseUrl: 'https://assess-api.nside.io',
    tipsApiBaseUrl: 'https://tips-v2.nside.io'
};
  